export const calculateTotalADR = (bookingList) => {
  const totalAmount = bookingList.reduce(
    (sum, booking) => sum + booking.totalamount,
    0
  );
  const totalRoomDays = bookingList.reduce((sum, booking) => {
    const numberOfRooms = booking.rooms.reduce(
      (roomSum, room) => roomSum + room.numberOfRooms,
      0
    );
    return sum + booking.totaldays * numberOfRooms;
  }, 0);
  return totalRoomDays > 0 ? (totalAmount / totalRoomDays).toFixed(2) : 0;
};
